import { Module } from "vuex";
import { RootState } from "..";
import { PLATFORM_LOGS_ACTIONS } from "./platformLogs.actions";
import { PLATFORM_LOGS_MUTATIONS } from "./platformLogs.mutations";
import { PLATFORM_LOGS_GETTERS } from "./platformLogs.getters";
import {
    PlatformLog,
    PlatformLogPagination,
    PlatformLogStats,
    PlatformLogAppliedFilters,
    PlatformLogsFilters,
} from "@/interfaces/panel/platform-logs.model";

export interface PlatformLogsState {
    loading: boolean;
    platformLogs: PlatformLog[];
    pagination: PlatformLogPagination;
    stats: PlatformLogStats;
    appliedFilters: PlatformLogAppliedFilters;
    filters: PlatformLogsFilters;
}

const INITIAL_STATE: PlatformLogsState = {
    loading: false,
    platformLogs: [],
    pagination: {
        page: 1,
        pageSize: 25,
        totalItems: 0,
        totalPages: 0,
    },
    stats: {
        byStatus: {
            SUCCESS: 0,
            FAILED: 0,
            PENDING: 0,
        },
        byType: {
            USER_ACTION: 0,
            ADMIN_ACTION: 0,
            SYSTEM_ACTION: 0,
            FINANCIAL: 0,
            SECURITY: 0,
        },
    },
    appliedFilters: {
        types: [],
        statuses: [],
        actions: [],
        userId: null,
        targetUserId: null,
        adminId: null,
        referenceId: null,
        search: null,
    },
    filters: {
        page: 1,
        pageSize: 25,
        sortBy: "createdAt",
        sortOrder: "desc",
        includeTotals: true,
        withRelations: true,
    },
};

export const platformLogs: Module<PlatformLogsState, RootState> = {
    actions: PLATFORM_LOGS_ACTIONS,
    getters: PLATFORM_LOGS_GETTERS,
    mutations: PLATFORM_LOGS_MUTATIONS,
    state: INITIAL_STATE,
    namespaced: true,
};
